import { render, staticRenderFns } from "./SurveyQuestionsScreenSectionCard.vue?vue&type=template&id=2b4212f0&scoped=true"
import script from "./SurveyQuestionsScreenSectionCard.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsScreenSectionCard.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionsScreenSectionCard.vue?vue&type=style&index=0&id=2b4212f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4212f0",
  null
  
)

export default component.exports